import { parsePhoneNumber } from 'awesome-phonenumber';
import { InferType, object, string } from 'yup';

import { agentPreferenceLocationSchema } from '@cloud-wave/neon-common-lib';

export const extendedAgentPreferenceFormSchema = object({
  location: agentPreferenceLocationSchema,
  callbackNumber: string()
    .required('Callback Number is required.')
    .test('callbackNumber', 'Your callback number must be a valid E.164 phone number.', (value) => {
      if (!value) {
        return true;
      }

      const phoneNumber = parsePhoneNumber(value);

      return phoneNumber.valid;
    })
    .default(null),
  confirmCallbackNumber: string().optional().default(null),
  updatedLocation: agentPreferenceLocationSchema.nullable(),
});

export type TExtendedAgentPreferenceFormSchema = InferType<typeof extendedAgentPreferenceFormSchema>;
